import * as React from 'react';

interface IOptionalAnchorProps {
  href?: string;
  rel?: string;
  target?: string;
  className?: string;
  onAnchorClick?(e: React.MouseEvent<HTMLAnchorElement>): void;
  children?: React.ReactNode;
}

export function OptionalAnchor(props: IOptionalAnchorProps) {
  const { href, rel, target, onAnchorClick, ...elementProps } = props;

  if (!href) {
    return <span {...elementProps} data-testid="OptionalAnchor" />;
  }

  return (
    // oxlint-disable-next-line react/jsx-no-target-blank
    <a {...elementProps} href={href} rel={rel} target={target} onClick={onAnchorClick} data-testid="OptionalAnchor" />
  );
}
